import React from 'react';
import { useParams } from 'react-router-dom';

const PublicDocument = () => {
  const { token } = useParams();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Documento Público
          </h1>
          <p className="text-gray-600 mb-4">
            Token: {token}
          </p>
          <div className="text-center py-8">
            <p className="text-gray-500">
              Funcionalidad de documentos públicos disponible en la aplicación completa
            </p>
            <a 
              href="https://app.bluecmr.com" 
              className="mt-4 inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700"
            >
              Ir a la Aplicación
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicDocument;